import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaGlobe, FaChevronDown } from 'react-icons/fa';
import { useLanguage } from '../../contexts/LanguageContext';
import './Footer.css';

const Footer = () => {
  const { t } = useTranslation();
  const { language, changeLanguage, supportedLanguages } = useLanguage();
  const currentYear = new Date().getFullYear();
  
  const [isLanguageMenuOpen, setIsLanguageMenuOpen] = useState(false);
  const languageDropdownRef = useRef(null);

  const toggleLanguageMenu = () => {
    setIsLanguageMenuOpen(!isLanguageMenuOpen);
  };

  // Умное закрытие селектора при клике вне его области
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (languageDropdownRef.current && !languageDropdownRef.current.contains(event.target)) {
        setIsLanguageMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Названия языков для отображения
  const languageNames = {
    en: 'English',
    es: 'Español', 
    pt: 'Português',
    hi: 'हिन्दी',
    ja: '日本語',
    ko: '한국어',
    de: 'Deutsch',
    fr: 'Français',
    ar: 'العربية',
    ru: 'Русский'
  };

  // Обработчик смены языка с закрытием меню
  const handleLanguageChange = (lang) => {
    changeLanguage(lang);
    setIsLanguageMenuOpen(false);
  };

  return (
    <footer className="footer">
      <div className="footer__container">
        <div className="footer__content">
          
          {/* Копирайт - расположен как логотип в Header (слева) */}
          <div className="footer__copyright">
            &copy; {currentYear} YTPULSE
          </div>

          {/* Середина - Ссылки */}
          <div className="footer__links">
            <Link to="/privacy" className="footer__link">
              {t('footer.privacy') || 'Конфиденциальность'}
            </Link>
            <Link to="/terms" className="footer__link">
              {t('footer.terms') || 'Условия использования'}
            </Link>
          </div>
          
          {/* Языковой селектор - расположен как в Header (справа) */}
          <div className="footer__language" ref={languageDropdownRef}>
            <div className={`footer__dropdown ${isLanguageMenuOpen ? 'footer__dropdown--open' : ''}`}>
              <button 
                className="footer__dropdown-toggle"
                onClick={toggleLanguageMenu}
              >
                <FaGlobe style={{ marginRight: '0.5rem' }} />
                {languageNames[language]}
                <FaChevronDown className="footer__dropdown-icon" />
              </button>
              
              {isLanguageMenuOpen && (
                <div className="footer__dropdown-menu footer__dropdown-menu--left">
                  {supportedLanguages.map((lang) => (
                    <button
                      key={lang}
                      className={`footer__dropdown-item ${
                        lang === language ? 'footer__language-option--active' : ''
                      }`}
                      onClick={() => handleLanguageChange(lang)}
                    >
                      {languageNames[lang]}
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>

        </div>
      </div>
    </footer>
  );
};

export default Footer;